import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

console.log("App is initializing...");

const root = document.getElementById("root");
if (root) {
  console.log("Root element found, rendering app...");
  createRoot(root).render(<App />);
} else {
  console.error("Root element not found! Check your index.html file.");
}
